import React, { useState, useContext } from 'react';
import Loading from '../Loading';
import { useForm } from 'react-hook-form';
import { Container, Row, Col } from 'react-bootstrap';
import PostOptions from './PostOptions';
import { useHistory } from 'react-router-dom';
import { OFFICER_POST_LIST, SETASIDE_CODE_LIST } from '../../constans';
import { TabContext } from '../../context/TabContext';
import ActionContainer from './ActionContainer';
import { contractOpportunityPost } from '../../api';
import { UserContext } from '../../context/User';
import { somethingWentWrongNotice, dateRequireNotice } from '../UI/Notifications';
import date from 'date-and-time';

const DEFAULT_INPUT_VALUES = {
  name: "",
  description: "",
  agency_name: "",
  requestor_name: "",
  required_date: "",
  closing_date: "",
  naics: "",
  part_number: "",
  quantity: "",
  city: "",
  state: "",
  zip: "",
  setaside_code: "",
  comment: "",
  link: ""
}

const OfficerPost = () => {
  const { setUser, setIsLoggedIn, user } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, errors } = useForm();
  const [inputValue, setInputValue] = useState(DEFAULT_INPUT_VALUES)
  const [selectValue, setSelectValue] = useState([]);
  const [list, setList] = useState([]);
  const history = useHistory();

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Search");
    }

    setLoading(false);
  }

  const handleMultiDelete = (name, valuesFunc, valuesValue) => {
    switch (name.action) {
      case 'remove-value':
        valuesFunc([...valuesValue.filter(el => el.value !== name.removedValue.value)]);
        break;
      case 'clear':
        valuesFunc([...valuesValue.filter(el => el.type !== name.name)]);
        break;
      default:
    }
  }

  const handleMultiAdd = (item, valuesFunc, valuesValue) => {
    switch (item.type) {
      case 'setaside_code':
        valuesFunc([...valuesValue, item]);
        break;
      default:
        valuesFunc([...valuesValue.filter(i => i.type !== item.type), item]);
    }
  }

  const onChangeHandler = (value, name, action) => {
    setList(SETASIDE_CODE_LIST);

    if (action && action.action === "input-change") {
      setInputValue({ ...inputValue, [name]: value });
    }

    if (!value) setList([]);
  }

  const onChangeSingleValue = (event, name, infoType) => {
    setInputValue({
      ...inputValue,
      [name]: event.target.value
    })
  }

  const handleMultiChange = (event, name) => {
    const item = Array.isArray(event) ? event[event.length - 1] : "";

    if (name.removedValue || name.removedValues) {
      handleMultiDelete(name, setSelectValue, selectValue);
    } else if (item) {
      handleMultiAdd(item, setSelectValue, selectValue);
    } else if (event && event.type) {
      setSelectValue([...selectValue, event]);
    }
  }

  const dataTransformation = params => {
    for (let prop in params) {
      if (
        params[prop] === null || 
        params[prop] === undefined ||
        params[prop] === "" ||
        params[prop].length === 0
      ) {
        delete params[prop];
      }
    }

    return params;
  }

  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoading(true);
    
    let obj = {
      setaside_code: []
    };

    selectValue.forEach((item) => {
      obj[item.type].push(item.value);
    })

    const params = {
      ...data,
      ...obj,
      required_date: inputValue.required_date,
      closing_date: inputValue.closing_date
    }

    const transformedParams = dataTransformation(params);

    if (!(
      'required_date' in transformedParams && 
      'name' in transformedParams &&
      'description' in transformedParams &&
      'agency_name' in transformedParams &&
      'closing_date' in transformedParams &&
      'setaside_code' in transformedParams &&
      'naics' in transformedParams
      )) {
      dateRequireNotice("Purchase Name, Line Item Description, Agency Name, Date Requested, Closing Date, Primary NAICS and Business Type/Set-Aside are required fields.");
      setLoading(false);
    } else {
      request(transformedParams)
    }
  };

  const request = (transformedParams) => {
    contractOpportunityPost(transformedParams)
      .then(response => {
        setLoading(false);
        history.push('/dashboard');
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        setLoading(false);
      })
  }

  const handleTimeCallback = (start, name) => {
    const formattedDate = date.format(start._d, 'YYYY-MM-DD');
   
    setInputValue({
      ...inputValue,
      [name]: formattedDate
    })
  }

  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5">
              Post Micro Purchase
            </h3>
          </Col>
        </Row>
        <TabContext.Provider value={{
          register,
          handleMultiChange, 
          onChangeHandler, 
          list, 
          inputValue, 
          selectValue, 
          setInputValue, 
          setSelectValue,
          onChangeSingleValue,
          handleTimeCallback,
          errors
        }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                <PostOptions inputList={OFFICER_POST_LIST} />
              </Col>
            </Row>
            <Row>
              <Col>
                <ActionContainer />
              </Col>
            </Row>
          </form>
        </TabContext.Provider>
      </Container>
      {loading && <Loading />}
    </section>
  )
}

export default OfficerPost;